module.exports = __webpack_public_path__ + "static/media/114.f073c838.mp3";